import React from 'react';
import {
	Box,
	Container,
	Text,
	SimpleGrid,
	VStack,
	HStack,
	Link,
	Divider,
	Icon,
	Flex,
	Image,
} from '@chakra-ui/react';
import { MdEmail, MdPhone, MdLocationOn } from 'react-icons/md';
import { FaShoppingCart, FaBoxOpen, FaClipboardList } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import logoImage from '../assets/logo.png';

const Footer = () => {
	const year = new Date().getFullYear();

	return (
		<Box bg="linear-gradient(135deg, #0f3460 0%, #16213e 100%)" color="white">
			{/* Green accent bar */}
			<Box bg="green.400" h="4px" />

			<Container maxW="container.xl" py={12}>
				<SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} spacing={10}>
					{/* Brand */}
					<VStack align="start" spacing={4}>
						<Image src={logoImage} alt="Correct Sales" h="40px" filter="brightness(1.2)" />
						<Text fontSize="sm" color="whiteAlpha.700" lineHeight="tall" maxW="220px">
							Your trusted partner for facility supplies and procurement. Quality products, competitive prices.
						</Text>
					</VStack>

					{/* Shop */}
					<VStack align="start" spacing={3}>
						<Text fontWeight="bold" fontSize="sm" color="green.300" textTransform="uppercase" letterSpacing="wider" mb={1}>
							Shop
						</Text>
						<Link as={NavLink} to="/store" fontSize="sm" color="whiteAlpha.800" _hover={{ color: 'green.300', textDecoration: 'none' }} display="flex" alignItems="center" gap={2}>
							<Icon as={FaShoppingCart} boxSize={3} />
							All Products
						</Link>
						<Link as={NavLink} to="/cart" fontSize="sm" color="whiteAlpha.800" _hover={{ color: 'green.300', textDecoration: 'none' }} display="flex" alignItems="center" gap={2}>
							<Icon as={FaBoxOpen} boxSize={3} />
							My Cart
						</Link>
						<Link as={NavLink} to="/order" fontSize="sm" color="whiteAlpha.800" _hover={{ color: 'green.300', textDecoration: 'none' }} display="flex" alignItems="center" gap={2}>
							<Icon as={FaClipboardList} boxSize={3} />
							My Orders
						</Link>
					</VStack>

					{/* Support */}
					<VStack align="start" spacing={3}>
						<Text fontWeight="bold" fontSize="sm" color="green.300" textTransform="uppercase" letterSpacing="wider" mb={1}>
							Support
						</Text>
						<Link href="#" fontSize="sm" color="whiteAlpha.800" _hover={{ color: 'green.300', textDecoration: 'none' }}>
							Privacy Policy
						</Link>
						<Link href="#" fontSize="sm" color="whiteAlpha.800" _hover={{ color: 'green.300', textDecoration: 'none' }}>
							Terms of Service
						</Link>
						<Link href="#" fontSize="sm" color="whiteAlpha.800" _hover={{ color: 'green.300', textDecoration: 'none' }}>
							Help Center
						</Link>
					</VStack>

					{/* Contact */}
					<VStack align="start" spacing={3}>
						<Text fontWeight="bold" fontSize="sm" color="green.300" textTransform="uppercase" letterSpacing="wider" mb={1}>
							Contact
						</Text>
						<HStack spacing={2} align="start">
							<Icon as={MdEmail} boxSize={4} color="green.300" mt={0.5} flexShrink={0} />
							<Text fontSize="sm" color="whiteAlpha.800">cs@correctcommissary.com</Text>
						</HStack>
						<HStack spacing={2} align="start">
							<Icon as={MdPhone} boxSize={4} color="green.300" mt={0.5} flexShrink={0} />
							<Text fontSize="sm" color="whiteAlpha.800">(318)224-7121</Text>
						</HStack>
						<HStack spacing={2} align="start">
							<Icon as={MdLocationOn} boxSize={4} color="green.300" mt={0.5} flexShrink={0} />
							<Text fontSize="sm" color="whiteAlpha.800">United States</Text>
						</HStack>
					</VStack>
				</SimpleGrid>
			</Container>

			<Divider borderColor="whiteAlpha.200" />

			<Container maxW="container.xl" py={5}>
				<Flex
					direction={{ base: 'column', md: 'row' }}
					justify="space-between"
					align="center"
					gap={2}
				>
					<Text fontSize="sm" color="whiteAlpha.600">
						© {year} Correct Sales. All rights reserved.
					</Text>
					<HStack spacing={4}>
						<Link href="#" fontSize="sm" color="whiteAlpha.500" _hover={{ color: 'green.300', textDecoration: 'none' }}>
							Privacy
						</Link>
						<Link href="#" fontSize="sm" color="whiteAlpha.500" _hover={{ color: 'green.300', textDecoration: 'none' }}>
							Terms
						</Link>
					</HStack>
				</Flex>
			</Container>
		</Box>
	);
};

export default Footer;
